import * as Actions from 'store/actions/app/order_items.actions'
import { addOrUpdateObjectInArray } from 'utils/add-or-update-object-in-array'
import { toggleIdInArray } from 'utils/toggle-id-in-array'

const initialState = {
  loading_items_by_order: false,
  items_by_order: [],

  saving_order_item: false,
  saved_order_item: false,

  adding_quantity_to_order_item_ids: [],
  added_quantity_to_order_item_ids: [],

  subtracting_quantity_to_order_item_ids: [],
  subtracted_quantity_to_order_item_ids: [],

  saving_order_item_description_ids: [],
  saved_order_item_description_ids: [],

  updating_order_item_quantity_ids: [],
  updated_order_item_quantity_ids: [],

  updating_order_item_price_ids: [],
  updated_order_item_price_ids: [],

  removing_order_item_ids: [],
  removed_order_item_ids: [],
}

const orderItemsReducer = function (state = initialState, action) {
  switch (action.type) {
    case Actions.GET_ITEMS_BY_ORDER_ID: {
      return {
        ...state,
        loading_items_by_order: action.payload.loading,
        items_by_order: action.payload.data ?? state.items_by_order,
      }
    }
    case Actions.SAVE_ORDER_ITEM: {
      return {
        ...state,
        saved_order_item: action.payload.saved ?? false,
        saving_order_item: action.payload.saving ?? false,
        items_by_order: action.payload.data
          ? addOrUpdateObjectInArray(state.items_by_order, action.payload.data, 'pedido_detalle_id', true)
          : state.items_by_order
      }
    }
    case Actions.ADD_QUANTITY_TO_ORDER_ITEM: {
      return {
        ...state,
        adding_quantity_to_order_item_ids: toggleIdInArray(state.adding_quantity_to_order_item_ids, action.payload.adding_id),
        added_quantity_to_order_item_ids: toggleIdInArray(state.added_quantity_to_order_item_ids, action.payload.added_id),
        items_by_order: action.payload.data
          ? addOrUpdateObjectInArray(state.items_by_order, action.payload.data, 'pedido_detalle_id')
          : state.items_by_order
      }
    }
    case Actions.SUBTRACT_QUANTITY_TO_ORDER_ITEM: {
      return {
        ...state,
        subtracting_quantity_to_order_item_ids: toggleIdInArray(state.subtracting_quantity_to_order_item_ids, action.payload.subtracting_id),
        subtracted_quantity_to_order_item_ids: toggleIdInArray(state.subtracted_quantity_to_order_item_ids, action.payload.subtracted_id),
        items_by_order: action.payload.data
          ? addOrUpdateObjectInArray(state.items_by_order, action.payload.data, 'pedido_detalle_id')
          : state.items_by_order
      }
    }
    case Actions.SAVE_ORDER_ITEM_DESCRIPTION: {
      return {
        ...state,
        saving_order_item_description_ids: toggleIdInArray(state.saving_order_item_description_ids, action.payload.saving_id),
        saved_order_item_description_ids: toggleIdInArray(state.saved_order_item_description_ids, action.payload.saved_id),
        items_by_order: action.payload.data
          ? addOrUpdateObjectInArray(state.items_by_order, action.payload.data, 'pedido_detalle_id')
          : state.items_by_order
      }
    }
    case Actions.UPDATE_ORDER_ITEM_QUANTITY: {
      return {
        ...state,
        updating_order_item_quantity_ids: toggleIdInArray(state.updating_order_item_quantity_ids, action.payload.updating_id),
        updated_order_item_quantity_ids: toggleIdInArray(state.updated_order_item_quantity_ids, action.payload.updated_id),
        items_by_order: action.payload.data
          ? addOrUpdateObjectInArray(state.items_by_order, action.payload.data, 'pedido_detalle_id')
          : state.items_by_order
      }
    }
    case Actions.UPDATE_ORDER_ITEM_PRICE: {
      return {
        ...state,
        updating_order_item_price_ids: toggleIdInArray(state.updating_order_item_price_ids, action.payload.updating_id),
        updated_order_item_price_ids: toggleIdInArray(state.updated_order_item_price_ids, action.payload.updated_id),
        items_by_order: action.payload.data
          ? addOrUpdateObjectInArray(state.items_by_order, action.payload.data, 'pedido_detalle_id')
          : state.items_by_order
      }
    }
    case Actions.REMOVE_ORDER_ITEM: {
      return {
        ...state,
        removing_order_item_ids: toggleIdInArray(state.removing_order_item_ids, action.payload.removing_id),
        removed_order_item_ids: toggleIdInArray(state.removed_order_item_ids, action.payload.removed_id),
        items_by_order: state.items_by_order.filter(item => item.pedido_detalle_id !== action.payload.removed_id)
      }
    }
    default: {
      return state
    }
  }
}

export default orderItemsReducer
